export const getContainer = (container, namespace) => {
    const parent = container.parentNode || document;
    const existing = parent.querySelector(`[data-react-component~="${namespace}"]`);
    if (existing) {
        return existing;
    }
    const reactContainer = document.createElement('div');
    reactContainer.setAttribute('data-react-component', namespace);
    parent.insertBefore(reactContainer, container);
    return reactContainer;
};
const isBlank = (input) => {
    return /^\s*$/.test(input);
};
export const getStringOrUndefined = (input) => {
    if (!input || isBlank(input)) {
        return undefined;
    }
    return input;
};
const getExternalConfig = (container) => {
    try {
        const configReference = container.getAttribute('data-config-reference');
        if (!configReference) {
            return undefined;
        }
        const configContainer = document.querySelector(`script[data-config-id="${configReference}"]`);
        const configContent = getStringOrUndefined(configContainer?.innerText);
        if (configContent) {
            return JSON.parse(configContent);
        }
        return undefined;
    }
    catch (e) {
        console.warn('Failed to parse external config', e);
        return undefined;
    }
};
const getLocalConfig = (container) => {
    try {
        const configText = getStringOrUndefined(container.innerText);
        return configText ? JSON.parse(configText) : {};
    }
    catch (e) {
        console.warn('Failed to parse local config', e);
        return {};
    }
};
export const getConfig = (container) => {
    try {
        return getExternalConfig(container) ?? getLocalConfig(container);
    }
    catch (e) {
        console.warn('Failed to parse config', e);
        return {};
    }
};
//# sourceMappingURL=data:application/json;base64,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